<template>
  <v-container fluid mb-4>
    <v-row align-content="center" justify="center">
      <v-col align-self="center">
        <v-card class="elevation-12">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Процесс торгов (подача заявки по торговой процедуре № {0})', [ lot.lotNumber ] ) }}
            </v-toolbar-title>
          </v-toolbar>
          <v-progress-linear v-if="isLoading" color="loader" indeterminate />

          <bidding-f-o-b v-if="!isLoading && isFOB" :lot="lot" />
          <bidding-not-f-o-b v-if="!isLoading && !isFOB" :lot="lot" />
          <v-card-actions>
            <v-row class="text-left">
              <v-col ma-1>
                <v-btn
                    id="toLotBtn"
                    v-test="{ btn: 'toLot' }"
                    class="ma-2"
                    color="primary"
                    @click.stop="toLot">
                  {{ $t('К торговой процедуре') }}
                </v-btn>
                <v-btn
                    id="toLotListBtn"
                    v-test="{ btn: 'toLotList' }"
                    class="ma-2"
                    color="primary"
                    @click.stop="toLotList">
                  {{ $t('К списку торговых процедур') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import BiddingFOB from './BiddingFOB.vue'
  import BiddingNotFOB from './BiddingNotFOB.vue'
  import { mapActions, mapState } from 'vuex'
  import { LOT_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      BiddingFOB,
      BiddingNotFOB
    },
    props: {
      lotId: {
        type: String,
        required: true
      },
      lotType: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapState(LOT_MANAGEMENT.NAMESPACE, {
        currentLot: state => (state[LOT_MANAGEMENT.STATE.CURRENT_LOT])
      }),
      lot () {
        return this.currentLot || {
          lotId: this.lotId,
          lotType: this.lotType
        }
      },
      isFOB () {
        return !this.lot.hasBasises
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        if (vm.lotId) {
          vm.initialize()
        }
      })
    },
    // чистим установщик текущего времени и подключение
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(LOT_MANAGEMENT.NAMESPACE, {
        getLotInfoAction: LOT_MANAGEMENT.ACTIONS.GET_LOT_INFO,
        clearLotInfoAction: LOT_MANAGEMENT.ACTIONS.CLEAR_LOT_INFO
      }),
      closeAlert: function (index) {
        this.newOrders.splice(index, 1)
      },
      clearStore: async function () {
        await Promise.all(
          [
            this.clearLotInfoAction()
          ])
      },
      initialize: async function () {
        try {
          const model = {
            lotId: this.lotId,
            lotType: this.lotType
          }
          this.isLoading = true

          await Promise.all([
            this.getLotInfoAction(model)
          ])
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      toLot: function () {
        this.goToRoute(`${this.urlRootPath}/lot/${this.lotType}/${this.lotId}`)
      },
      toLotList: function () {
        this.goToRoute(`${this.urlRootPath}/lots/personal/registered`)
      }
    }
  }
</script>
